import { createSlice } from '@reduxjs/toolkit';

const tagsSlice = createSlice({
  name: 'tags',
  initialState: {
    list: [],
  },
  reducers: {
    setTags: (state, action) => {
      state.list = action.payload;
    },
    addTags: (state, action) => {
        console.log('...........tagsss' , state)
      state.list.push(action.payload);
    },
    updateTags: (state, action) => {
      const index = state.list.findIndex(tag => tag._id === action.payload._id);
      if (index !== -1) {
        state.list[index] = action.payload;
      }
    },
 
deleteTags: (state, action) => {
  state.list = state.list.filter(tag => tag._id !== action.payload);
}

  },
});

export const {
  setTags,
  addTags,
  updateTags,
  deleteTags
} = tagsSlice.actions;

export default tagsSlice.reducer;
